import React, { useEffect, useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import PortalPageHeader from '../../common/PortalPageHeader';
import { AdminPageDetails, PageDetails } from '../config';
import { getData } from '../../../DataAccessLayer';
import { sam } from '../../../DataAccessLayer/services';
import PortalDataGridPro from '../../common/PortalDataGridPro';
import { getColumns } from './columns';
import { JobProcessingBanner } from '../JobProcessingBanner';

export const RulesUpdateReport = () => {
  const [id] = useState('rulesUpdateReport');
  const [title, setTitle] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [rulesUpdateHistory, setRulesUpdateHistory] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  //θ(N) where N is the number of pages in PageDetails
  //Retrieve page title from pageDetails using pageid
  const loadPageTitle = () => {
    const page = Object.values(AdminPageDetails).find((page) => page.id === id);

    setTitle(page.title);
  };

  const loadBreadcrumbs = () => {
    const page = Object.values(AdminPageDetails).find((page) => page.id === id);

    setBreadcrumbs(page.breadcrumbs);
  };

  const getRulesUpdateHistory = async () => {
    setIsLoading(true);
    try {
      const data = await getData(sam.advisorRules().getAll, true);

      setRulesUpdateHistory(data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadPageTitle();
    getRulesUpdateHistory();
    loadBreadcrumbs();
  }, []);

  return (
    <>
      <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`} style={{}}>
        <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
          <PortalPageHeader
            id={id}
            title={title}
            breadcrumbs={breadcrumbs}
            banner={<JobProcessingBanner />}
          />

          <Box id={`${id}__box_wrapper`}>
            <PortalDataGridPro
              rows={rulesUpdateHistory}
              getRowId={(row) => row.CREATED_AT}
              columns={getColumns(rulesUpdateHistory)}
              isLoading={isLoading}
              pagination
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 20,
                    page: 0,
                  },
                },
              }}
              disableRowSelectionOnClick
              slotProps={{
                loadingOverlay: {
                  noRowsVariant: 'skeleton',
                },
              }}
              slots={{
                noRowsOverlay: () => {
                  return (
                    <Box mt={1} display="flex" justifyContent="center">
                      <Typography variant="p" component="p">
                        No rules update records found.
                      </Typography>
                    </Box>
                  );
                },
              }}
            />
          </Box>
        </Container>
      </div>
    </>
  );
};
